import axios from 'axios'
import getConfig from 'next/config'

const {
  publicRuntimeConfig: { stripeApiKey },
} = getConfig()

const api = axios.create({
  baseURL: 'https://api.stripe.com/v1/',
})

api.interceptors.request.use(request => {
  request.headers.Authorization = `Bearer ${stripeApiKey}`
  console.log('request token', request)
  return request
})

async function createTokenWithCard({ number, name, cvc, expMonth, expYear }) {
  const query = new URLSearchParams()
  query.append('card[number]', number)
  query.append('card[name]', name)
  query.append('card[cvc]', cvc)
  query.append('card[exp_month]', expMonth)
  query.append('card[exp_year]', expYear)

  return await api
    .post('/tokens', query)
    .then(res => {
      console.log('responose token', res)
      return res.data.id
    })
    .catch(error => {
      throw new Error('決済情報の登録ができません。入力情報をご確認ください')
    })
}

export { createTokenWithCard }
